// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1cLqs","controls":"styles_controls__3ExB6","charLimit":"styles_charLimit__1z2bl","input":"styles_input__Wzqw3","send":"styles_send__aDH5I"};